import { gql } from '@apollo/client';

export const CREATE_USER_COUNSELLING = gql`
  mutation createUserCounselling($input: UserCounsellingInput!) {
    createUserCounselling(input: $input) {
      idx
      student_idx
      teacher_idx
      title
      detail
      idate
      student_name
      teacher_name
    }
  }
`;
